import axios from 'axios/index';
import {defaultBehaviour} from "../utils/ServiceUtils";

function getPersonalInformation(userId, okCallback, koCallback) {
    return defaultBehaviour(axios.get(`/user/getName/${userId}`), okCallback, koCallback);
}

function savePersonalInformation(userId, userAndCompanyNamePayload, okCallback, koCallback) {
    return defaultBehaviour(
        axios.post(`/user/changeName/${userId}`, userAndCompanyNamePayload), okCallback, koCallback);
}

function changePassword(userId, changeUserPasswordPayload, okCallback, koCallback) {
    return defaultBehaviour(
        axios.post(`/user/changePassword/${userId}`, changeUserPasswordPayload), okCallback, koCallback);
}

export default {getPersonalInformation, savePersonalInformation, changePassword};
